webpackJsonp([32],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .controller('AcceptPrivacyPolicyCtrl', ['$scope', '$location', '$state', '$window', 'NotificationService',
        'UserService', 'NavigationService', 'UrlService',
        function ($scope, $location, $state, $window, NotificationService,
                  UserService, NavigationService, UrlService) {

            $scope.window = angular.element("#acceptPrivacyPolicyForm").kendoWindow({
                actions: [],
                modal: true,
                pinned: true,
                resizable: false,
                title: "Privacy Policy Acknowledgement",
                width: "360px",
                visible: false,
                autoFocus: false,
                close: function () {
                    UserService.showRequiredFormIfAnyNeeded();
                },
                deactivate: function () {
                    $scope.window.destroy();
                }
            }).data("kendoWindow").center().open();

            $scope.acceptPrivacyPolicy = function () {
                UserService.acceptPrivacyPolicy(
                    function successCallback() {
                        NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                            currentAccount.privacyPolicyAccepted = true;
                        });
                        $scope.window.close();
                    }, function errorCallback(responseError) {
                        var errorMsg = responseError.message;
                        if (errorMsg) {
                            NotificationService.showErrorMessage(errorMsg);
                        }
                        $scope.formErrors = [];
                        angular.forEach(responseError.validationErrors, function (error) {
                            $scope.formErrors.push(error);
                        });
                    })
            };

            $scope.logOut = function () {
                $window.location.href = UrlService.createAbsoluteUrl('/useradmin/logout.jsp');
            };
        }]);

/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

angular.module('appMarketplace')
    .service('UserService', ['$http', '$state', 'UrlService', 'NavigationService', function ($http, $state, UrlService, NavigationService) {
        var service = this;

        service.getUserInfo = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/userInfo')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.getAccountCodePreference = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/accountCodePreference')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updateUser = function (user, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/userInfo'),
                data: user
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getEmailCategoryGroups = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/emailCategoryGroups')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updateCategoryGroups = function (categoryIds, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/emailCategoryGroups'),
                data: categoryIds
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getPasswordHint = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/passwordHint')
            };

            $http(req).then(function (response) {
                successCallback(response.data);
            }, function (response) {
                errorCallback(response.data)
            })
        };

        service.updatePasswordHint = function (questionId, questionAnswer, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentUser/passwordHint'),
                data: {
                    userQuestion: questionId,
                    userAnswer: questionAnswer
                }
            };

            $http(req).then(successCallback, function (response) {
                errorCallback(response.data)
            })
        };

        service.getApprovalDelegationSettings = function (successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/approvalDelegation')
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.updateApprovalDelegationSettings = function (settings, successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/approvalDelegation'),
                data: settings
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.isAccountCodeValid = function (codeAccount, columnNumber, successCallback, errorCallback) {
            var req = {
                method: 'GET',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/accountCodeValidity/' + codeAccount),
                params: {column_number: columnNumber}
            };

            $http(req).then(function successCallbackWrapper(response) {
                successCallback(response.data.accountCodeValid);
            }, function errorCallbackWrapper(response) {
                errorCallback(response.data)
            })
        };

        service.acceptPrivacyPolicy = function (successCallback, errorCallback) {
            var req = {
                method: 'POST',
                url: UrlService.createAbsoluteUrl('/rest/currentAccount/acceptPrivacyPolicy')
            };

            $http(req).then(successCallback,
                function errorCallbackWrapper(response) {
                    errorCallback(response.data)
                })
        };

        service.showRequiredFormIfAnyNeeded = function (changeLocation) {
            NavigationService.getCurrentAccount(function successCallback(currentAccount) {
                var state = 'root-state';
                if (!currentAccount.privacyPolicyAccepted) {
                    state = 'accept-privacy-policy-state';
                } else if (currentAccount.passwordUpdateNeeded) {
                    state = 'update-password-state';
                } else if (currentAccount.passwordHintUpdateNeeded) {
                    state = 'update-password-hint-state';
                }
                if ($state.current.name === state) {
                    return;
                }
                $state.go(state, null, {location: changeLocation});
            });
        }
    }]);


/***/ }),

/***/ 477:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(33);
__webpack_require__(202);

/***/ })

},[477]);


// WEBPACK FOOTER //
// acceptPrivacyPolicyEntry.js?ver=bed5e7a4c7698d3e042c